import TextFieldBase from '../../components/TextFieldBase/TextFieldBase';
import ITextFieldProps from './TextFieldProps';

const TextField = ({ value, type = 'text', ...rest }: ITextFieldProps) => (
  <TextFieldBase inputTag="input" type={type} value={value ? value : ''} {...rest} />
);

export default TextField;
